<!-- Start Page Title Area -->
<div class="page-title-area page-title-bg2">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Pricing</h2>
                    <ul>
                        <li><a routerLink="/" itemprop="url" title="EWNS, Custom Ecommerce Platform to meet all your digital needs">Home</a></li>
                        <li>Pricing</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape-img8"><img src="assets/img/shape/shape8.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</div>
<!-- End Page Title Area -->

<!-- Start Pricing Area -->
<section class="pricing-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            <br/><br/>
            <span class="sub-title">Pricing Plan</span>
            <h2>Choose Your Best Plan</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-pricing-box red">
                    <div class="pricing-header">
                        <h3>Basic</h3>
                    </div>
                    <div class="price">
                        <sub>₹</sub>
                        25,000
                        <sub>/Yr</sub>
                    </div>
                    <ul class="price-features-list">
                        <li><i class="flaticon-tick"></i> 1 Website</li>
                        <li><i class="flaticon-tick"></i> 1 Email, Unlimited Hosting</li>
                        <li><i class="flaticon-tick"></i> SSL encryption</li>
                        <li><i class="flaticon-tick"></i> 99% Availability</li>
                        <li><i class="flaticon-tick"></i> Onboarding Content Curation</li>
                        <li><i class="flaticon-tick"></i> Content Management Portal</li>
                        <li><i class="flaticon-tick"></i> Hyper Local SEO</li>
                        <li><i class="flaticon-tick"></i> Digital Marketing (addon)</li>
                        <li><i class="flaticon-close"></i> Ecommerce</li>
                        <li><i class="flaticon-close"></i> Customize Theme </li>
                    </ul>
                    <a href="https://portal.ewns.in/signup" title="Get Started" class="get-started-btn">Get Started</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-pricing-box ">
                    <div class="pricing-header">
                        <h3>Premium</h3>
                    </div>
                    <div class="price">
                        <sub>₹</sub>
                        50,000
                        <sub>/yr</sub>
                    </div>
                    <ul class="price-features-list">
                        <li><i class="flaticon-tick"></i> 1 Website</li>
                        <li><i class="flaticon-tick"></i> 3 Emails, Unlimited Web Hosting</li>
                        <li><i class="flaticon-tick"></i> SSL encryption</li>
                        <li><i class="flaticon-tick"></i> 99% Availability</li>
                        <li><i class="flaticon-tick"></i> Editorial Services</li>
                        <li><i class="flaticon-tick"></i> Content Management Portal</li>
                      
                        <li><i class="flaticon-tick"></i> Hyper Local SEO</li>
                        <li><i class="flaticon-tick"></i> Digital Marketing (addon)</li>
                        <li><i class="flaticon-tick"></i> Ecommerce</li>
                       
                        <li><i class="flaticon-tick"></i> Customized Theme</li>
                    </ul>
                    <a href="https://portal.ewns.in/signup" title="Get Started" class="get-started-btn">Get Started</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-pricing-box orange">
                    <div class="pricing-header">
                        <h3>Enterprise</h3>
                    </div>
                    <div >
                        <h2 style="font-size: 50px; font-weight: 700;">Talk to Us</h2>
                    </div>
                    <ul class="price-features-list">
                        <li><i class="flaticon-tick"></i> 1 Website</li>
                        <li><i class="flaticon-tick"></i>  Unlimited Web Hosting</li>
                        <li><i class="flaticon-tick"></i> SSL encryption</li>
                        <li><i class="flaticon-tick"></i> 99% Availability</li>
                        <li><i class="flaticon-tick"></i> Editorial Services</li>
                        <li><i class="flaticon-tick"></i> Content Management Portal</li>
                      
                        <li><i class="flaticon-tick"></i> Hyper Local SEO</li>
                        <li><i class="flaticon-tick"></i> Digital Marketing</li>
                        <li><i class="flaticon-tick"></i> Ecommerce</li>
                       
                        <li><i class="flaticon-tick"></i> Customization</li>
                    </ul>
                    <a routerLink="/contact" title="Contact us" class="get-started-btn">Contact Us</a>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img6"><img src="assets/img/shape/shape6.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</section>
<!-- End Pricing Area -->